import { render, staticRenderFns } from "./YoutubeTrailerSwitching.vue?vue&type=template&id=b398d9a4&"
import script from "./YoutubeTrailerSwitching.vue?vue&type=script&lang=js&"
export * from "./YoutubeTrailerSwitching.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/kellymcnamara/git/gotconquest.com/web/app/themes/got/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b398d9a4')) {
      api.createRecord('b398d9a4', component.options)
    } else {
      api.reload('b398d9a4', component.options)
    }
    module.hot.accept("./YoutubeTrailerSwitching.vue?vue&type=template&id=b398d9a4&", function () {
      api.rerender('b398d9a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/scripts/components/slider/YoutubeTrailerSwitching.vue"
export default component.exports